import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CopyIco from "../../../../assets/icons/CopyIco";
import GenerateIco from "../../../../assets/icons/GenerateIco";
import GenerateSearchString from "../../../../assets/icons/GenerateSearchString";
import SaveSearchIco from "../../../../assets/icons/SaveSearchIco";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import CommonButton from "../../../../component/Button";
import DropDownSelect from "../../../../component/Select";
import {
  GenerateSearchStringPOST,
  SaveSearchStringSkill,
  SearchStringSkills,
} from "../../../../redux/action/Job";
import { ShowSnackbar } from "../../../../redux/action/ShowSnackbar";
import { HandleSkeletion, highlightBoolean } from "../../../../utils/constants";
import CommonTable from "../../../candidates/Table";
import { CustomDiv } from "../../../chat-bot/style";
import {
  CommonGrid2,
  CustomTooltip,
} from "../../../common-components/StyledComponents";
import { CommonTippy, CustomizeTableCell } from "../../style";
import { StyledDialog } from "../../../common-components/StyledComponents";

export default function GenerateSearchStringContent({
  jobData,
  generateSearch,
  handleCopyClick,
  handleCopyMouseLeave,
  handleDialogClose,
  jobId,
}) {
  const [data, setData] = useState({
    selectedType: "Generic",
    loading: true,
    soft_skills: [],
    hard_skills: [],
    boolean_search_strings: "",
    generate_loading: false,
    save_loading: false,
    estimated_resume_count: "",
  });
  const [confirmSaveOpen, setConfirmSaveOpen] = useState(false);
  const dispatch = useDispatch();

  const handleSelectAll = (type) => {
    setData((prev) => {
      const key = type === "hard" ? "hard_skills" : "soft_skills";
      const list = prev[key];
      const allIncluded =
        list.length > 0 &&
        list.every((item) => item.include_type === "INCLUDE");
      const updatedList = list.map((item) => ({
        ...item,
        include_type: allIncluded ? "EXCLUDE" : "INCLUDE",
      }));
      return {
        ...prev,
        [key]: updatedList,
      };
    });
  };

  const getHeaderData = (type) => [
    { name: "Name", key: "name" },
    { name: "Relevancy", key: "relevancy" },
    {
      name: (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          gap={0.5}
        >
          <Typography fontSize="13px" fontWeight={600}>
            All
          </Typography>
          <Checkbox
            size="small"
            checked={
              type === "hard"
                ? data.hard_skills.length > 0 &&
                  data.hard_skills.every(
                    (item) => item.include_type === "INCLUDE"
                  )
                : data.soft_skills.length > 0 &&
                  data.soft_skills.every(
                    (item) => item.include_type === "INCLUDE"
                  )
            }
            disabled={data.loading}
            onChange={() => handleSelectAll(type)}
            sx={{
              p: 0.5,
              color: "#D0D5DD",
              "&.Mui-checked": { color: "#7F56D9" },
            }}
          />
        </Box>
      ),
      key: "all",
      textAlign: "end",
    },
  ];

  const handleSearchString = async ({ selectedType = data.selectedType }) => {
    try {
      setData((prev) => ({
        ...prev,
        loading: true,
      }));
      let params = {
        platform_type: selectedType,
      };
      const search_data = await SearchStringSkills(jobId, params);
      setData((prev) => ({
        ...prev,
        soft_skills: search_data.soft_skills || [],
        hard_skills: search_data.hard_skills || [],
        boolean_search_strings: search_data.boolean_search_strings || "",
        estimated_resume_count: search_data?.estimated_resume_count,
      }));
      setData((prev) => ({
        ...prev,
        loading: false,
      }));
    } catch (error) {
      dispatch(
        ShowSnackbar({
          open: true,
          message: error.message,
          severity: "error",
        })
      );
      setData((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleGenerateSearchString = async (condition) => {
    try {
      setData((prev) => ({
        ...prev,
        generate_loading: condition === "generate" ? true : false,
        save_loading: condition === "save" ? true : false,
      }));
      const filter_data = [...data.hard_skills, ...data.soft_skills].filter(
        (item) => item.include_type === "INCLUDE"
      );
      let payload = {
        job_id: jobId,
        platform_type: data.selectedType,
        core_skills_data: filter_data,
        ...(condition === "save" && {
          boolean_search_string: data.boolean_search_strings,
        }),
      };
      const search_data =
        condition === "save"
          ? await SaveSearchStringSkill(jobId, payload)
          : await GenerateSearchStringPOST(jobId, payload);
      if (condition === "save") {
        await handleSearchString({});
      } else {
        setData((prev) => ({
          ...prev,
          generate_loading: false,
          save_loading: false,
          boolean_search_strings:
            search_data?.data?.boolean_search_string || "",
          estimated_resume_count: search_data?.data?.estimated_resume_count,
        }));
      }
      dispatch(
        ShowSnackbar({
          open: true,
          message: search_data.message,
          severity: "success",
        })
      );

      setData((prev) => ({
        ...prev,
        generate_loading: false,
        save_loading: false,
      }));
    } catch (error) {
      dispatch(
        ShowSnackbar({
          open: true,
          message: error.message,
          severity: "error",
        })
      );
      setData((prev) => ({
        ...prev,
        generate_loading: false,
        loading: false,
      }));
      setData((prev) => ({
        ...prev,
        generate_loading: false,
        save_loading: false,
      }));
    }
  };

  useEffect(() => {
    handleSearchString({ selectedType: data.selectedType });
  }, []);

  const handleCheckboxChange = (row, type) => {
    setData((prev) => {
      const key = type === "hard" ? "hard_skills" : "soft_skills";

      const updatedList = prev[key].map((item) => {
        if (item.skill_id === row.skill_id) {
          return {
            ...item,
            include_type:
              item.include_type === "INCLUDE" ? "EXCLUDE" : "INCLUDE",
          };
        }
        return item;
      });
      return {
        ...prev,
        [key]: updatedList,
      };
    });
  };

  const handleTableBodyData = (row, index, type) => {
    const isChecked =
      type === "hard"
        ? row.include_type === "INCLUDE"
        : row.include_type === "INCLUDE";

    return (
      <Fragment>
        <CustomizeTableCell padding="4px 8px">
          <CommonTippy
            content={row.skill_name}
            placement="top"
            color={"#7F56D9"}
            fontSize="12px"
            bottom={"5px"}
          >
            <Typography
              variant="subtitle3"
              fontWeight="600"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                width: "80px",
              }}
            >
              {row.skill_name}
            </Typography>
          </CommonTippy>
        </CustomizeTableCell>

        <CustomizeTableCell textAlign="center" padding="4px 8px">
          {row.relevancy_score === null || row.relevancy_score === 0 ? (
            "-"
          ) : (
            <Box
              sx={{
                display: "inline-flex", // important
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "#ECFDF3",
                color: "#067647",
                borderRadius: "12px",
                px: 1,
                py: "1px",
                fontSize: "11px",
                fontWeight: 500,
                border: "1px solid #ABEFC6",
              }}
            >
              {row.relevancy_score} %
            </Box>
          )}
        </CustomizeTableCell>

        <CustomizeTableCell textAlign="end" padding="4px 8px">
          <Checkbox
            size="small"
            checked={isChecked}
            onChange={() => handleCheckboxChange(row, type)}
            sx={{
              p: 0.5,
              color: "#D0D5DD",
              "&.Mui-checked": { color: "#7F56D9" },
            }}
          />
        </CustomizeTableCell>
      </Fragment>
    );
  };
  const typeOptions = [
    { name: "Generic", value: "Generic" },
    { name: "Monster", value: "Monster" },
    { name: "Techfetch", value: "Techfetch" },
  ];

  const handleDropDown = (e) => {
    setData((prev) => ({
      ...prev,
      selectedType: e.target.value,
    }));
    handleSearchString({ selectedType: e.target.value });
  };

  const handleConfirmSaveClose = () => setConfirmSaveOpen(false);
  const handleConfirmSaveYes = async () => {
    handleConfirmSaveClose();
    await handleGenerateSearchString("save");
  };
  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth={"md"}
        open={generateSearch.open}
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            background: "#FFF",
            boxShadow:
              "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
          },
        }}
      >
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <GenerateSearchString />
          <Button onClick={handleDialogClose}>
            <XCloseIco />
          </Button>
        </DialogActions>

        <DialogContent sx={{ paddingTop: "0px" }}>
        <CustomDiv marginBottom="20px" textAlign={"start"}>
          <Typography fontSize="20px" fontWeight={700} display="block">
            Generate Boolean Search String
          </Typography>
          <CommonGrid2
            display={"flex"}
            flexDirection={"row"}
            gap={"20px"}
            marginTop={"5px"}
          >
            <CommonGrid2 width={"60%"}>
              <Typography variant="body4" color="#6B7280" fontWeight={500}>
                Choose the skills you need to include in the search string and
                click generate.
              </Typography>
            </CommonGrid2>
            <CommonGrid2 width={"40%"}>
              <Typography fontWeight={700} color="Search" variant="body4">
                Search String
              </Typography>
            </CommonGrid2>
          </CommonGrid2>
        </CustomDiv>

        <CommonGrid2
          width="100%"
          display="flex"
          flexDirection="row"
          gap="20px"
          marginTop={"20px"}
          alignItems="stretch"
        >
          <CommonGrid2
            width="60%"
            display="flex"
            flexDirection="column"
            border={"2px solid #EAECF0"}
            borderRadius={"12px"}
            padding={"12px"}
          >
            <CommonGrid2
              display="flex"
              flexDirection="row"
              flexWrap={"wrap"}
              container
              spacing={3}
            >
              <CommonGrid2
                item
                size={6}
                display="flex"
                justifyContent="flex-start"
                flexDirection={"column"}
              >
                <Typography fontWeight={600} textAlign={"start"}>
                  Hard Skills
                </Typography>
                <CommonTable
                  marginTop={"8px"}
                  data={data.hard_skills}
                  columns={getHeaderData("hard")}
                  loadingRowLength={5}
                  handleTableBodyData={(row, index) =>
                    handleTableBodyData(row, index, "hard")
                  }
                  loading={data.loading}
                  customStyle={{
                    boxShadow: "none",
                    border: "none",
                    overflowX: "visible",
                    "& .MuiTableHead-root": {
                      backgroundColor: "white",
                      fontSize: "13px",
                      "& th": {
                        padding: "8px !important",
                        fontWeight: 600,
                      },
                    },
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      height: "5px",
                      display: "block",
                    },
                    ...(data.loading && {
                      "& .MuiTableCell-root": {
                        padding: "10px",
                      },
                    }),
                  }}
                />
              </CommonGrid2>

              <CommonGrid2
                item
                size={6}
                display="flex"
                justifyContent="flex-start"
                flexDirection={"column"}
                height="calc(100% - 30px)"
              >
                <Typography fontWeight={600} textAlign={"left"}>
                  Soft Skills
                </Typography>
                <CommonTable
                  marginTop={"8px"}
                  data={data.soft_skills}
                  columns={getHeaderData("soft")}
                  loadingRowLength={5}
                  handleTableBodyData={(row, index) =>
                    handleTableBodyData(row, index, "soft")
                  }
                  loading={data.loading}
                  customStyle={{
                    boxShadow: "none",
                    border: "none",
                    overflowX: "visible",
                    "&::-webkit-scrollbar": {
                      width: "5px",
                      height: "5px",
                      display: "block",
                    },
                    "& .MuiTableHead-root": {
                      backgroundColor: "white",
                      fontSize: "13px",
                      "& th": {
                        padding: "8px !important",
                        fontWeight: 600,
                      },
                    },
                    ...(data.loading && {
                      "& .MuiTableCell-root": {
                        padding: "10px",
                      },
                    }),
                  }}
                />
              </CommonGrid2>
            </CommonGrid2>
          </CommonGrid2>

          <CommonGrid2
            width="40%"
            border={"2px solid #EAECF0"}
            borderRadius={"12px"}
            padding={"12px"}
            flexGrow={1}
          >
            <Typography
              display={"flex"}
              justifyContent={"start"}
              marginBottom={1}
            >
              Type
            </Typography>

            <CommonGrid2
              display="flex"
              flexDirection="column"
              gap="1rem"
              height={"calc(100% - 30px)"}
            >
              <CommonGrid2 display="flex" flexDirection="row" gap={"1rem"}>
                <DropDownSelect
                  customStyle={{ width: "200px" }}
                  marginTop="0px"
                  sizeMedium="-8px"
                  padding="9px"
                  title="Select Type"
                  removeAnimation={true}
                  data={typeOptions}
                  value={data.selectedType}
                  handleChange={(e) => {
                    handleDropDown(e);
                  }}
                  disabled={data.loading}
                />
                <CommonButton
                  value={"Generate"}
                  width={"50%"}
                  fontWeight={500}
                  startIcon={!data.generate_loading && <GenerateIco />}
                  gap={data.generate_loading ? "10px" : "0px"}
                  disabled={data.loading || data.generate_loading || data?.selectedType === "Generic"}
                  loading={data.generate_loading}
                  onClick={() => handleGenerateSearchString("generate")}
                />
              </CommonGrid2>

              <CommonGrid2
                background="#F5F6F7"
                padding="10px"
                borderRadius="12px"
                height={"100%"}
                display={"flex"}
                flexDirection={"column"}
                justifyContent={"space-between"}
              >
                {data.loading ? (
                  <HandleSkeletion height={50} transform={"scale(1)"} />
                ) : (
                  <Typography
                    component="div"
                    color="green"
                    variant={"subtitle3"}
                    textAlign={"left"}
                    dangerouslySetInnerHTML={{
                      __html: highlightBoolean(data.boolean_search_strings),
                    }}
                  />
                )}
                <CommonGrid2 display="flex" justifyContent="right">
                  <CustomTooltip
                    arrow
                    placement="top"
                    title={
                      generateSearch?.copied ? "Copied!" : "Copy to Clipboard"
                    }
                    fontSize="12px"
                    padding="5px 10px"
                    margin="0px 0px 10px !important"
                  >
                    <CustomDiv margin="10px 0px 0px">
                      <CommonButton
                        value="Copy String"
                        padding="6px 1rem"
                        width="max-content"
                        fontWeight={600}
                        background={"white"}
                        fontSize={"13px"}
                        color="#344054"
                        border="#EAECF0"
                        startIcon={<CopyIco size={18} />}
                        gap="0px"
                        onClick={() =>
                          handleCopyClick(data.boolean_search_strings)
                        }
                        onMouseLeave={handleCopyMouseLeave}
                        boxShadow={"0px 1px 2px 0px #1018280D"}
                        disabled={data.loading}
                      />
                    </CustomDiv>
                  </CustomTooltip>
                </CommonGrid2>
              </CommonGrid2>

              {data.selectedType !== "Generic" &&
                typeof data?.estimated_resume_count?.count === "number" && (
                  <Fragment>
                    {data.loading ? (
                      <HandleSkeletion height={50} transform={"scale(1)"} />
                    ) : (
                      <CommonGrid2
                        width="100%"
                        background="#E5FFF0"
                        borderRadius="10px"
                        display="flex"
                        alignItems="center"
                        gap="10px"
                        padding="5px"
                      >
                        <Typography
                          color="white"
                          backgroundColor={"#17B26A"}
                          borderRadius={"50px"}
                          padding={"4px 12px"}
                          width={"max-content"}
                        >
                          {data?.estimated_resume_count?.count}
                        </Typography>

                        <CommonGrid2 display={"flex"} flexDirection={"column"}>
                          <Typography fontWeight={600}>
                            Candidates Available
                          </Typography>
                          {data?.estimated_resume_count?.error && (
                            <Typography
                              variant="subtitle2"
                              fontWeight={600}
                              lineHeight={"15px"}
                              color="red"
                            >
                              {data?.estimated_resume_count?.error}
                            </Typography>
                          )}
                        </CommonGrid2>
                      </CommonGrid2>
                    )}
                  </Fragment>
                )}
            </CommonGrid2>
          </CommonGrid2>
        </CommonGrid2>

        <CommonGrid2 display={"flex"} justifyContent={"right"}>
          <CommonButton
            variant="outlined"
            color="#5A35B2"
            value={`Save String For ${data?.selectedType === "Generic" ? "External" : data?.selectedType} Search`}
            gap={data.save_loading ? "10px" : "0px"}
            padding={"8px 2rem"}
            fontWeight={700}
            disabled={
              data.loading || data.save_loading || data?.selectedType === "Generic"
            }
            startIcon={!data.save_loading && <SaveSearchIco color="#5A35B2" />}
            margin={"1rem 0px 0px"}
            loading={data.save_loading}
            svg={true}
            customStyle={{
              "&:hover svg path": {
                fill: "#fff",
              },
            }}
            onClick={() => setConfirmSaveOpen(true)}
          />
        </CommonGrid2>
        </DialogContent>
      </Dialog>

      <StyledDialog
        fullWidth
        maxWidth="xs"
        open={confirmSaveOpen}
        onClose={handleConfirmSaveClose}
      >
        <DialogActions>
          <CommonButton
            onClick={handleConfirmSaveClose}
            padding={"10px"}
            background={"rgba(127, 86, 217, 0.04)"}
            border="rgba(127, 86, 217, 0.5)"
            height={"100%"}
            value={<XCloseIco />}
            boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
          />
        </DialogActions>

        <DialogTitle>
          <Typography variant="h3" sx={{ mt: 2 }}>
            Confirm save
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography
            color="#475467"
            fontSize={14}
            fontFamily={"Inter"}
            fontWeight={500}
            sx={{ mb: 2 }}
          >
            The selected string will be used for external search on{" "}
            <span style={{ color: "#101828", fontWeight: 600 }}>
              {data?.selectedType}
            </span>
            . Do you want to continue?
          </Typography>

          <CommonGrid2 display="flex" gap="12px">
            <CommonButton
              value="No"
              width={"100%"}
              padding={"10px 14px"}
              variant="outlined"
              color="#344054"
              border="#EAECF0"
              fontWeight={600}
              onClick={handleConfirmSaveClose}
              disabled={data.save_loading}
            />
            <CommonButton
              value="Yes"
              width={"100%"}
              padding={"10px 14px"}
              variant="contained"
              background="#7F56D9"
              fontWeight={600}
              onClick={handleConfirmSaveYes}
              disabled={data.save_loading}
              loading={data.save_loading}
            />
          </CommonGrid2>
        </DialogContent>
      </StyledDialog>
    </Fragment>
  );
}
